import React, { memo } from 'react';

import { AccordionPanel, AccordionPanelProps } from '@chakra-ui/accordion';

interface IProps extends AccordionPanelProps {}

const AccordionBodyComponent: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <AccordionPanel padding="0" {...props}>
      {children}
    </AccordionPanel>
  );
};

export const AccordionBody = memo(AccordionBodyComponent);
